module.exports = __webpack_public_path__ + "img/pp-10.36b38ae5.jpg";